import React, { Component, Fragment } from "react";
import { Form } from "react-bootstrap";
import { Dropdown } from "semantic-ui-react";
import LoadingProgressBar from "../../spinners/LoadingProgressBar";
import AlertNoPermission from "../../alerts/AlertNoPermission";
import $ from "jquery";

class BarClientTypesDropdown extends Component {
    state = { loading: true, noPermission: false, barClientTypes: null };

    getBarClientTypes = async () => {
        const { fetchURL, onShowAlert, t } = this.props;

        try {
            const response = await fetch(`${fetchURL}/bar-client-types`, {
                credentials: "include",
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
            });
            if (response.status === 200) {
                await response.json().then((fetchedData) => {
                    //console.log(fetchedData);
                    if (fetchedData.status === "noPermission") this.setState({ noPermission: true });
                    else if (fetchedData.status === "notLogged") this.props.onShowHomePage();
                    else if (fetchedData.status === false) onShowAlert({ variant: "danger", message: t(`error.${fetchedData.code}`) });
                    else {
                        const barClientTypes = fetchedData.barClientTypes;
                        barClientTypes.unshift({ key: 0, value: "all", text: t("selectAll") });
                        this.setState({ barClientTypes: barClientTypes, loading: false });
                    }
                });
            }
        } catch (err) {
            onShowAlert({ variant: "danger", message: `${t("error.cannotFetchData")} (${err})` });
            this.setState({ loading: false });
        }
    };

    componentDidMount() {
        this.getBarClientTypes();
    }

    render() {
        const { noPermission, loading, barClientTypes } = this.state;
        const { t, selectedType, onSelectType } = this.props;
        return (
            <Fragment>
                <Form.Label className="w-100">{t("barClients.barClientType")}</Form.Label>
                {noPermission ? (
                    <AlertNoPermission t={t} />
                ) : barClientTypes && !loading ? (
                    <Dropdown
                        value={selectedType}
                        id="barClientTypesDropdown"
                        className="req mb-3"
                        placeholder={t("select")}
                        fluid
                        selection
                        options={barClientTypes}
                        onChange={(event, { value }) => {
                            $("#barClientTypesDropdown").removeClass("danger");
                            onSelectType(value);
                        }}
                    />
                ) : (
                    <LoadingProgressBar t={t} />
                )}
            </Fragment>
        );
    }
}

export default BarClientTypesDropdown;
